export default __webpack_public_path__ + "static/char-v-35-3a317d71e12213b5928d270251527cbc.png";